import { buildTokenHash, ogApiGet } from "//dev.bark.co/cdn/shop/t/97/assets/ordergroove-api.js?v=91429999985649944441750080727";

window.addEventListener("load", async function() {
  const nextOrder = JSON.parse(sessionStorage.getItem("og-next-order"));
  let nextOrderCustomerId;
  if (nextOrder) {
    nextOrderCustomerId = nextOrder.customer
  }
  const today = new Date();
  const nextOrderDate = !!nextOrder ? new Date(nextOrder.place) : null;
  const ogSigDataDiv = document.querySelector(".og-sig-data");
  const loggedInCustomerId = ogSigDataDiv.getAttribute('data-attr-customer-id');

  if (nextOrderDate > today && (!loggedInCustomerId || customerMatch(nextOrderCustomerId, loggedInCustomerId))) {
    return;
  }

  if (ogSigDataDiv) {
    try {
      const ordersUrl = "/orders/?status=1&ordering=place&exclude_prepaid_orders=true";
      const hasBarkSig = cookieContains('bark_signature');
      if (!loggedInCustomerId && !hasBarkSig) return;

      let tokenHash;
      if (loggedInCustomerId) {
        const ts = ogSigDataDiv.getAttribute('data-attr-ts');
        const hmac_sha = ogSigDataDiv.getAttribute('data-attr-hmac_sha');
        const sig = btoa(String.fromCharCode.apply(null, hmac_sha.match(/\w{2}/g).map(function(a) { return parseInt(a, 16) })));
        const ogMerchantId = ogSigDataDiv.getAttribute('data-attr-og-mid');

        tokenHash = buildTokenHash(
          ogMerchantId,
          loggedInCustomerId,
          ts,
          sig
        );
      }

      const orders = await ogApiGet(ordersUrl, tokenHash);

      if (orders.data.results.length > 0) {
        const nextOrder = orders.data.results[0];
        sessionStorage.setItem("og-next-order", JSON.stringify(nextOrder));
        document.dispatchEvent(
          new CustomEvent("ognextorderadded", { 
            detail: {
              nextOrder
            }
           })
        );
      } else {
        sessionStorage.removeItem("og-next-order");
      }
    } catch (error) {
      console.log(error);
      newrelic.noticeError(error, { customerId });
    }
  }

  function customerMatch(nextOrderCId, loggedInCId) {
    return !!nextOrderCId && !!loggedInCId && nextOrderCId == loggedInCId;
  }
})
